/** @jsxImportSource @emotion/react */

import React, { ReactNode } from 'react';
import AutoOrientationService from '../../../services/autoOrientation';
import { CSSProp } from '../../../types/emotion';

export interface GridLayoutProps {
  /**
   * Number of columns for each breakpoint [sm, md, lg], default is [1, 2, 3]
   */
  columns?: number[];
  /**
   * Grid content
   */
  children: ReactNode;
}

/**
 * The `GridLayout` component is used to display content in a grid.
 */
export function GridLayout({
  columns = [],
  children,
  ...props
}: GridLayoutProps & Omit<Partial<React.HTMLAttributes<HTMLDivElement>>, keyof GridLayoutProps> & CSSProp) {
  columns = [1, 2, 3].map((e, i) => columns[i] ?? e);

  return (
    <div
      css={{
        display: 'grid',
        gap: '1.5rem',
        ...AutoOrientationService.multiBreakpointStyles({
          sm: { gridTemplateColumns: templateColumns(columns[0]) },
          md: { gridTemplateColumns: templateColumns(columns[1]) },
          lg: { gridTemplateColumns: templateColumns(columns[2]) },
        }),
      }}
      {...props}
    >
      {children}
    </div>
  );
}

const templateColumns = (columns: number) => Array(columns).fill('1fr').join(' ');
